var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterGradient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 50,
    viewBox: "0 0 61 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5521 37.8499C14.3281 37.7708 10.6637 35.3472 8.80112 31.8059C10.1925 31.8467 11.5462 31.6736 12.8197 31.3251L12.7376 28.8943C8.01326 27.9384 4.5573 24.0588 3.83802 19.5917C5.16872 20.0778 6.59551 20.3639 8.07743 20.4121L12.4146 20.5532L8.81711 18.1265C4.32532 15.0965 2.7103 9.41373 4.54522 4.58511C10.8941 11.646 19.9 16.2359 29.9769 16.7452L31.6309 16.8288L31.2578 15.2152C29.6102 8.08872 34.9735 1.25 42.2323 1.25C45.4694 1.25 48.398 2.62762 50.4514 4.83728L50.9264 5.34835L51.6107 5.2124C53.317 4.8734 54.9644 4.36924 56.5352 3.71749C55.6362 4.97362 54.4882 6.03746 53.1659 6.83609L53.9617 9.14709C55.115 9.00811 56.2451 8.79554 57.3478 8.51305C56.3297 9.58967 55.2147 10.5723 54.019 11.4436L53.4764 11.839L53.5064 12.5096C54.2741 29.6969 41.57 48.75 19.1845 48.75C14.1445 48.75 9.36118 47.6484 5.04988 45.6769C10.2077 45.2737 15.1606 43.3569 19.3041 40.0801L22.0417 37.9152L18.5521 37.8499Z",
    fill: "url(#twittergradient_paint0_linear_325_1158)",
    stroke: "black",
    strokeWidth: 2.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "twittergradient_paint0_linear_325_1158",
    x1: 30.5,
    y1: 0,
    x2: 30.5,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CFDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCA2F8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterGradient);
export default __webpack_public_path__ + "static/media/twitter_gradient.5e3fd046383d28b13ae4e1ec1ed88555.svg";
export { ForwardRef as ReactComponent };